/* eslint-disable no-use-before-define */
import React from 'react'
import { fmt, arrayFrom } from '../../twd'

export default ({alerts}) => {

    alerts = arrayFrom(alerts)
    if (alerts.length===0) {
        return <div
            data-name="alerts-modal-not-found"
            className="text-center">
            <div className="vertical-offset-xs">
            <i className="et-icon et-alert et-icon-md" aria-hidden="true"></i>
            </div>
            <div className="vertical-offset-xs">
            <div className="small-header vertical-offset-xxs">No holding alerts found.</div>
            </div>
        </div>
    }

    return <div className="table-responsive" style={{maxWidth:'100%', overflowY:'auto'}}>
    <table data-name="alerts-modal-table" className="table table-striped" >
    <thead>
    <tr>
    <th className="text-left"><h4 className="small-header">Holding Alerts</h4></th>
    </tr>
    </thead>

    <tbody>{
        (alerts)
        .map( (r,i) => {
            return <tr data-name="alerts-modal-row" key={i}>
            <td><HoldingAlerts {...r} /></td>
            </tr>
        })
    }</tbody>

    </table>
    </div>
}

const HoldingAlerts = ({alertDate, alertDescription, cusip, issue, maturity, coupon, acctNo, qty}) => {
    return <React.Fragment>
        <div className="text-body">
        <p>{fmt.mdy(alertDate)} <span className="subhead">{alertDescription}</span></p>
        <p>{fmt.issuer({
            cusip,
            issuer: `${issue || cusip || ''} ${fmt.cpn(coupon)} ${fmt.mdy(maturity)}`,
            showBackLink: 'N',
            className: 'link-button'
        })}</p>
        <div className="equally-spaced">
            <div style={{width:'50%'}}>Account #: <span className="text-bold">{acctNo}</span></div>
            <div style={{width:'50%'}}>Quantity: <span className="text-bold">{fmt.qty(qty)}</span></div>
        </div>
        </div>
        </React.Fragment>
}